import { Pipe, PipeTransform } from '@angular/core';
import { NogoshIconName, nogoshIconClass } from './nogosh-icons.generated';

@Pipe({
  name: 'nogoshIcon',
  standalone: true,
})
export class NogoshIconPipe implements PipeTransform {
  transform(name: NogoshIconName): string {
    return nogoshIconClass(name);
  }
}
